import { useContext, useEffect } from "react";
import { UserStore } from "../..";
import BreadCrumbs from "../../components/breadcrumsb";
import { PageContainer } from "../../components/page";
import { runAuthHandler } from "../util";
import { useNavigate } from "react-router";
import MobileAttractorCreator from "./MobileAttractorCreator";

const PAGE_TITLE = "Create Mobile Attractor";

const CreateMobileAttractorPage = () => {
  const navigate = useNavigate();
  const userStore = useContext(UserStore);
  const { selectedVenue } = userStore;

  useEffect(() => {
    runAuthHandler({ userStore, navigate });
  }, [selectedVenue]);

  return (
    <PageContainer>
      <BreadCrumbs
        routes={[
          { path: "/home", breadcrumbName: "Home" },
          { path: "/mobile-attractors", breadcrumbName: "Mobile Attractors" },
          {
            path: "/mobile-attractors/create",
            breadcrumbName: "Create Mobile Attractor",
          },
        ]}
      />
      <div className="text-3xl mb-6 text-center font-bold">{PAGE_TITLE}</div>
      <div className="w-full">
        <MobileAttractorCreator />
      </div>
    </PageContainer>
  );
};

export default CreateMobileAttractorPage;
